var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "test-wrapper" }, [
    !_vm.testPreview
      ? _c("section", [
          _vm._v(
            "\n            " +
              _vm._s(_vm.$t("MAIN_CONTENT.testTaker.loading")) +
              "\n        "
          )
        ])
      : _vm.testPreview && !_vm.testEndTime && !_vm.testStartTime
      ? _c("section", [
          _c("div", { staticClass: "pre-test" }, [
            _c("div", { staticClass: "display-table" }, [
              _c("div", [
                _c("div", { staticClass: "header text-center" }, [
                  _c("h1", [_vm._v(_vm._s(_vm.testPreview.TEST.TEST_TITLE))])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "content" }, [
                  _vm.testPreview.TEST.TEST_DESCRIPTION
                    ? _c("p", {
                        domProps: {
                          innerHTML: _vm._s(
                            _vm.testPreview.TEST.TEST_DESCRIPTION
                          )
                        }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _c("div", { staticClass: "test-meta" }, [
                    _c("div", [
                      _c("label", [
                        _vm._v(
                          _vm._s(
                            _vm.$t(
                              "MAIN_CONTENT.testTaker.takeTester_windowOpen"
                            )
                          )
                        )
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "pill pill-gray-light" }, [
                        _vm._v(
                          _vm._s(
                            _vm._f("datetime")(
                              _vm.testPreview.TEST.TEST_WINDOW_OPEN
                            )
                          )
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", [
                      _c("label", [
                        _vm._v(
                          _vm._s(
                            _vm.$t(
                              "MAIN_CONTENT.testTaker.takeTester_windowCloses"
                            )
                          )
                        )
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "pill pill-gray-light" }, [
                        _vm._v(
                          _vm._s(
                            _vm._f("datetime")(
                              _vm.testPreview.TEST.TEST_WINDOW_CLOSED
                            )
                          )
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _vm.testPreview.TEST.TIME_LIMIT
                      ? _c("div", [
                          _c("label", [
                            _vm._v(
                              _vm._s(
                                _vm.$t(
                                  "MAIN_CONTENT.testTaker.takeTester_duration"
                                )
                              )
                            )
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "pill pill-gray-light" }, [
                            _vm._v(
                              "\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t" +
                                _vm._s(
                                  _vm.$t(
                                    "MAIN_CONTENT.testTaker.takeTester_mins",
                                    { time: _vm.testPreview.TEST.TIME_LIMIT }
                                  )
                                ) +
                                "\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t"
                            )
                          ])
                        ])
                      : _vm._e()
                  ]),
                  _vm._v(" "),
                  _vm.testEnded
                    ? _c("div", { staticClass: "alert-panel alert-warning" }, [
                        _vm._m(0),
                        _vm._v(" "),
                        _c("div", { staticClass: "alert-message" }, [
                          _vm._v(
                            "\n                                    " +
                              _vm._s(
                                _vm.$t(
                                  "MAIN_CONTENT.testTaker.takeTester_testEndedMessage"
                                )
                              ) +
                              "\n                                "
                          )
                        ])
                      ])
                    : _vm.testExpired
                    ? _c("div", { staticClass: "alert-panel alert-warning" }, [
                        _vm._m(1),
                        _vm._v(" "),
                        _c("div", { staticClass: "alert-message" }, [
                          _vm._v(
                            "\n                                    " +
                              _vm._s(
                                _vm.$t(
                                  "MAIN_CONTENT.testTaker.takeTester_testExpired"
                                )
                              ) +
                              "\n                                "
                          )
                        ])
                      ])
                    : _vm.testPreview.TEST.SINGLE_SITTING_COMPLETION_FLG ||
                      _vm.testPreview.TEST.STUDENT_IMMEDIATE_FEEDBACK
                    ? _c("div", { staticClass: "alert-panel alert-info" }, [
                        _vm._m(2),
                        _vm._v(" "),
                        _c("div", { staticClass: "alert-message" }, [
                          _vm.testPreview.TEST.SINGLE_SITTING_COMPLETION_FLG
                            ? _c("p", [
                                _vm._v(
                                  "\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t" +
                                    _vm._s(
                                      _vm.$t(
                                        "MAIN_CONTENT.testTaker.takeTester_singleSession"
                                      )
                                    ) +
                                    "\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t"
                                )
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.testPreview.TEST.STUDENT_IMMEDIATE_FEEDBACK
                            ? _c("p", [
                                _vm._v(
                                  "\n                                        " +
                                    _vm._s(
                                      _vm.$t(
                                        "MAIN_CONTENT.testTaker.takeTester_immediateFeedback"
                                      )
                                    ) +
                                    "\n                                        "
                                ),
                                !_vm.testPreview.TEST.ALLOW_ANSWER_CHANGE
                                  ? _c("span", [
                                      _vm._v(
                                        "\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t" +
                                          _vm._s(
                                            _vm.$t(
                                              "MAIN_CONTENT.testTaker.takeTester_allowChange"
                                            )
                                          ) +
                                          "\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t"
                                      )
                                    ])
                                  : _vm._e()
                              ])
                            : _vm._e()
                        ])
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.testEnded && !_vm.testExpired
                    ? _c("div", { staticClass: "foo text-center" }, [
                        _c(
                          "button",
                          {
                            staticClass: "btn btn-success",
                            on: {
                              click: function($event) {
                                return _vm.beginTest()
                              }
                            }
                          },
                          [
                            _c("font-awesome-icon", {
                              attrs: { icon: "stopwatch" }
                            }),
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.$t(
                                    "MAIN_CONTENT.testTaker.takeTester_startNow"
                                  )
                                ) +
                                "\n                                "
                            )
                          ],
                          1
                        )
                      ])
                    : _c("div", { staticClass: "foo text-center" }, [
                        _c(
                          "button",
                          {
                            staticClass: "btn btn-primary",
                            on: {
                              click: function($event) {
                                return _vm.closeWindow()
                              }
                            }
                          },
                          [
                            _vm._v(
                              "\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t" +
                                _vm._s(
                                  _vm.$t(
                                    "MAIN_CONTENT.testTaker.takeTester_closeWindow"
                                  )
                                ) +
                                "\n                                "
                            )
                          ]
                        )
                      ])
                ])
              ])
            ])
          ])
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.testPreview && !_vm.testEnded && !_vm.testEndTime && _vm.testStartTime
      ? _c("section", [
          _c("div", { staticClass: "test-header" }, [
            _c("h1", [_vm._v(_vm._s(_vm.testPreview.TEST.TEST_TITLE))]),
            _vm._v(" "),
            this.mode !== "proxy" && _vm.testTimeRemaining > -1
              ? _c("div", { staticClass: "float-right" }, [
                  _c("i", {
                    class:
                      "fas fa-stopwatch " +
                      (_vm.testTimeRemaining > 0 ? "animate-flicker" : ""),
                    attrs: { "aria-hidden": "true" }
                  }),
                  _vm._v(" "),
                  _c("span", [
                    _vm._v(
                      "\n                        " +
                        _vm._s(_vm.testTimeRemaining) +
                        "\n                    "
                    )
                  ]),
                  _vm._v(
                    "\n                    " +
                      _vm._s(
                        _vm.$t("MAIN_CONTENT.testTaker.takeTester_minsLeft")
                      ) +
                      "\n                "
                  )
                ])
              : _vm._e()
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col-md-9" }, [
              _c(
                "div",
                {
                  staticClass: "testing-zone",
                  attrs: { id: "testZone", tabindex: "-1" }
                },
                [
                  _vm.activeQuestion &&
                  _vm.activeQuestion.QUESTION_TYPE &&
                  !_vm.timeLimitExceeded
                    ? _c("question-group", {
                        attrs: { group: _vm.activeQuestionGroup }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.activeQuestion &&
                  _vm.activeQuestion.QUESTION_TYPE &&
                  !_vm.timeLimitExceeded
                    ? _c(
                        "div",
                        {
                          attrs: {
                            "aria-live":
                              _vm.activeQuestion.SEQUENCE === 1
                                ? "off"
                                : "assertive"
                          }
                        },
                        [
                          _c("div", { staticClass: "extra-credit" }, [
                            _vm.activeQuestion.EXTRA_CREDIT_FLG
                              ? _c(
                                  "span",
                                  { staticClass: "pill pill-success-lighten" },
                                  [
                                    _vm.activeQuestion.EXTRA_CREDIT_FLG
                                      ? _c("font-awesome-icon", {
                                          attrs: {
                                            icon: "certificate",
                                            size: "2x",
                                            title: "Extra Credit Question"
                                          }
                                        })
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _c("span", { staticClass: "hidden-xs" }, [
                                      _vm._v(
                                        "\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t" +
                                          _vm._s(
                                            _vm.$t(
                                              "MAIN_CONTENT.testReviewer.extraCredit"
                                            )
                                          ) +
                                          "\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t"
                                      )
                                    ])
                                  ],
                                  1
                                )
                              : _vm._e()
                          ]),
                          _vm._v(" "),
                          _vm.activeQuestion.QUESTION_TYPE == "C"
                            ? _c("multiple-choice-question", {
                                attrs: {
                                  testPreview: _vm.testPreview,
                                  activeQuestion: _vm.activeQuestion,
                                  studentAnswer: _vm.studentAnswer,
                                  studentAnswers: _vm.studentAnswers,
                                  testMode: "student"
                                }
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.activeQuestion.QUESTION_TYPE == "T"
                            ? _c("true-false-question", {
                                attrs: {
                                  testPreview: _vm.testPreview,
                                  activeQuestion: _vm.activeQuestion,
                                  studentAnswer: _vm.studentAnswer,
                                  studentAnswers: _vm.studentAnswers,
                                  testMode: "student"
                                }
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.activeQuestion.QUESTION_TYPE == "S"
                            ? _c("short-fill-question", {
                                attrs: {
                                  testPreview: _vm.testPreview,
                                  activeQuestion: _vm.activeQuestion,
                                  studentAnswer: _vm.studentAnswer,
                                  studentAnswers: _vm.studentAnswers,
                                  blankAnswer: _vm.blankAnswer,
                                  testMode: "student"
                                }
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.activeQuestion.QUESTION_TYPE == "M"
                            ? _c("matching-question", {
                                attrs: {
                                  testPreview: _vm.testPreview,
                                  activeQuestion: _vm.activeQuestion,
                                  studentAnswer: _vm.studentAnswer,
                                  studentAnswers: _vm.studentAnswers,
                                  questions: _vm.questions,
                                  answers: _vm.answers,
                                  test: _vm.test,
                                  testMode: "student"
                                }
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.activeQuestion.QUESTION_TYPE == "N"
                            ? _c("numeric-question", {
                                attrs: {
                                  testPreview: _vm.testPreview,
                                  activeQuestion: _vm.activeQuestion,
                                  studentAnswer: _vm.studentAnswer,
                                  studentAnswers: _vm.studentAnswers,
                                  blankAnswer: _vm.blankAnswer,
                                  testMode: "student"
                                }
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.activeQuestion.QUESTION_TYPE == "E"
                            ? _c("essay-question", {
                                attrs: {
                                  testPreview: _vm.testPreview,
                                  activeQuestion: _vm.activeQuestion,
                                  studentAnswer: _vm.studentAnswer,
                                  studentAnswers: _vm.studentAnswers,
                                  blankAnswer: _vm.blankAnswer,
                                  testMode: "student"
                                }
                              })
                            : _vm._e()
                        ],
                        1
                      )
                    : _c(
                        "div",
                        {
                          staticClass: "test-confirm",
                          attrs: {
                            "aria-live": "assertive",
                            "aria-label": "confirm submission"
                          }
                        },
                        [_c("confirm-submission")],
                        1
                      )
                ],
                1
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-md-3" }, [
              _c("aside", [
                _c(
                  "div",
                  { staticClass: "question-nav" },
                  [_c("question-selector")],
                  1
                ),
                _vm._v(" "),
                _vm.testPreview.TEST.STUDENT_IMMEDIATE_FEEDBACK
                  ? _c("div", { staticClass: "score-wrap text-center" }, [
                      _c("span", { staticClass: "pill pill-dark" }, [
                        _c("strong", [
                          _vm._v(
                            "\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t" +
                              _vm._s(
                                _vm.$t(
                                  "MAIN_CONTENT.testReviewer.scoreOutOfTotal",
                                  {
                                    score: _vm.totalPointsEarned,
                                    total: _vm.testPreview.TEST.TOTAL_SCORE
                                  }
                                )
                              ) +
                              "\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t"
                          )
                        ]),
                        _vm._v(
                          " " +
                            _vm._s(_vm.$t("MAIN_CONTENT.testReviewer.points")) +
                            " \n\t\t\t\t\t\t\t\t\t\t\t\t\t"
                        )
                      ])
                    ])
                  : _vm._e()
              ])
            ])
          ])
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.testStartTime && _vm.testEndTime
      ? _c("section", [
          _c("div", { staticClass: "post-test" }, [
            _c("div", { staticClass: "display-table" }, [
              _c("div", { staticClass: "header text-center" }, [
                _c("h2", [_vm._v(_vm._s(_vm.testPreview.TEST.TEST_TITLE))])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "content" }, [
                _c("p", [
                  _c("b", [
                    _vm._v(
                      _vm._s(
                        _vm.$t("MAIN_CONTENT.testTaker.takeTester_submitted")
                      )
                    )
                  ])
                ]),
                _vm._v(" "),
                _vm.testPreview.TEST.ANSWERS_VISIBLE_AFTER_GRADING
                  ? _c("p", [
                      _vm._v(
                        "\n                            " +
                          _vm._s(
                            _vm.$t(
                              "MAIN_CONTENT.testTaker.takeTester_availableForReview"
                            )
                          ) +
                          "\n                        "
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c("div", { staticClass: "foo text-center" }, [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-primary",
                      on: {
                        click: function($event) {
                          return _vm.closeWindow()
                        }
                      }
                    },
                    [
                      _vm._v(
                        "\n                                " +
                          _vm._s(
                            _vm.$t(
                              "MAIN_CONTENT.testTaker.takeTester_closeWindow"
                            )
                          ) +
                          "\n                            "
                      )
                    ]
                  )
                ])
              ])
            ])
          ])
        ])
      : _vm._e()
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "alert-bar" }, [
      _c("i", { staticClass: "fas fa-info-circle" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "alert-bar" }, [
      _c("i", { staticClass: "fas fa-info-circle" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "alert-bar" }, [
      _c("i", {
        staticClass: "fas fa-info-circle",
        attrs: { "aria-hidden": "true" }
      })
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }